<template>
  <div>
    <ViewProjectPage />
  </div>
</template>

<script>
import ViewProjectPage from '@/components/ai/hr-projects/ViewProjectPage.vue';

export default {
  name: 'AIPage',
  components: {
    ViewProjectPage
  },
  data() {
    return {
    };
  },
};
</script>
